module.exports = __webpack_public_path__ + "img/preferences.143b4b7d.png";